export default __webpack_public_path__ + "static/media/soc_noncpa.fb38ce35.png";